import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom'
import TrackingsModule from '../components/TrackingsModule';
import { GetGroupTrackings } from '../../../store/GroupAction';
import { RequestState } from '../../../models/RequestState';
import { CoreTracking } from '../../../models/CoreTracking';
import { useTranslation } from 'react-i18next';
import { FlowSyncObjectType } from '../../../models/CoreModels';
import { RootState } from '../../../store/store';



const GroupViewTrackings = () => {
    const { t } = useTranslation(['schoolAdministration']);

    const { groupId } = useParams();
    const dispatch = useDispatch();
    const trackings = useSelector<RootState, RequestState<CoreTracking[]>>(state => state.groups.groupTrackings);

    useEffect(() => {
        if (groupId !== undefined) {
            GetGroupTrackings(groupId)(dispatch);
        }
    }, [dispatch, groupId]);

    const fetchTrackings = () => {
        if (groupId !== undefined) {
            GetGroupTrackings(groupId, true)(dispatch);
        }
    }
    return (<>
        <TrackingsModule
            flowSyncObjectType={FlowSyncObjectType.Group}
            trackings={trackings}
            noResMsg={t('trackingModule.noResMsg', { ns: 'schoolAdministration', type: t('type.group', { ns: 'schoolAdministration' }) })}
            onDataInvalidated={fetchTrackings}
        />
    </>)
}

export default GroupViewTrackings;
